<template>
  <div>
    <h4>Cartão de Crédito <span class="text-grey">(GalaxPay)</span></h4>
    <div class="mt-2">
      Um e-mail com os dados do pedido será enviado para <strong>{{ basket.email }}</strong>
    </div>
    <div class="mt-2 mb-4">
      Nós não armazenamos os dados do seu cartão em nosso sistema.
    </div>

    <div class="mb-2">
      <vs-input class="w-full" label="Nome Completo" placeholder="Nome Completo" v-model="basket.name" required
                tabindex="1"/>
    </div>
    <div class="mb-2">
      <vs-input class="w-full" label="WhatsApp" placeholder="WhatsApp" v-model="basket.telephone"/>
      <div>Deixe seu telefone WhatsApp para receber um atendimento personalizado.</div>
    </div>
    <div class="mb-2 mt-6">
      <strong>Dados do Cartão</strong>
    </div>
    <div class="mb-2">
      <vs-input
        class="w-full"
        label="Número do Cartão"
        placeholder="Somente números"
        v-model="basket.card_number"
        v-facade="['#### #### #### ####']"
        tabindex="1"
        required
      />
    </div>
    <div class="mb-2">
      <div class="flex">
        <div class="w-6/12 mr-4">
          <vs-input
            class="w-full"
            label="Data de Validade (Mês/Ano)"
            placeholder="Somente números (MM/AA)"
            v-model="basket.card_date"
            tabindex="1"
            autocomplete="cc-exp-month"
            v-facade="'##/##'"
            required
          />
        </div>

        <div class="w-6/12">
          <vs-input
            class="w-full"
            label="Código de Segurança (CVV)"
            placeholder="Somente números"
            maxlength="4"
            v-model="basket.card_cvv"
            tabindex="1"
            inputmode="numeric" pattern="[0-9]*"
            autocomplete="cc-csc"
            v-facade="['###', '####']"
            required
          />
        </div>
      </div>
      <div class="mb-2">
        <vs-input
          class="w-full"
          label="Nome que aparece no cartão"
          placeholder="Exatamente como está no cartão"
          v-model="basket.card_name"
          tabindex="1"
          required
        />
      </div>
      <div class="mb-2" v-if="basket.address_country === 'br'">
        <vs-input
          class="w-full"
          label="CPF/CNPJ do Titular do Cartão"
          placeholder="Somente números"
          v-facade="['###.###.###-##', '##.###.###/####-##']"
          v-model="basket.cpfcnpj"
          tabindex="1"
          :required="basket.address_country === 'br'"
        />
      </div>
      <div class="mb-2">
        <div class="flex">
          <div class="w-4/12 mr-4">
            <vs-input class="w-full" label="Código do País" placeholder="Código do País" v-model="basket.telephone_country_code" required
                      autocomplete="tel-country-code"
                      maxlength="6"
                      tabindex="1"
                      v-facade="'######'"/>
          </div>
          <div class="w-8/12">
            <vs-input class="w-full" label="Número Celular com DDD do Titular do Cartão" placeholder="Número Celular com DDD do Titular do Cartão" v-model="basket.telephone" required
                      autocomplete="tel-national"
                      tabindex="1"
                      v-facade="'##############'"/>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-2 mt-6">
      <strong>Endereço de Cobrança do Titular do Cartão</strong>
    </div>
    <div class="mt-2 mb-4">
      O endereço de cobrança tem que ser o mesmo endereço que está cadastro no banco ou operadora de cartão de crédito.
    </div>
    <div class="mb-2">
      <div class="flex">
        <div class="w-6/12 mr-0 md:mr-4">
          <vs-select label="País" v-model="basket.address_country" class="w-full">
            <vs-select-item :key="country.iso" :value="country.iso" :text="country.nome" v-for="country in countries"/>
          </vs-select>
        </div>
        <div class="w-6/12">
          <vs-input class="w-full" label="CEP" placeholder="CEP" v-model="basket.address_postcode" @input="checkCep" tabindex="1" required/>
        </div>
      </div>
    </div>
    <div class="mb-2">
      <div class="flex">
        <div class="w-4/5 mr-4">
          <vs-input class="w-full" label="Rua, Avenida" placeholder="Rua, Avenida" v-model="basket.address_street" tabindex="1" required/>
        </div>

        <div class="w-1/5">
          <vs-input class="w-full" label="Número" placeholder="Número" v-model="basket.address_number" tabindex="1" required="true"/>
        </div>
      </div>
    </div>
    <div class="mb-2">
      <div class="flex">
        <div class="w-2/5 mr-4">
          <vs-input class="w-full" label="Bairro" placeholder="Bairro" v-model="basket.address_complement" tabindex="1"/>
        </div>
        <div class="w-2/5 mr-4">
          <vs-input class="w-full" label="Cidade" placeholder="Cidade" v-model="basket.address_city" tabindex="1" required/>
        </div>
        <div class="w-1/5">
          <vs-input class="w-full" label="Estado" placeholder="UF" v-model="basket.address_state" tabindex="1" required/>
        </div>
      </div>
    </div>

    <vs-button type="relief" class="w-full mt-6" @click="next()">Continuar</vs-button>
    <vs-button type="relief" color="danger" class="w-full mt-6" @click="checkoutWizard.prevTab()">Voltar</vs-button>
  </div>
</template>

<script>
import {facade} from 'vue-input-facade'

export default {
  directives: {facade},
  props: {
    checkoutWizard: {
      type: Object,
      required: true
    },
    paymentMethod: {
      type: String,
      required: true
    },
    basket: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      countries: []
    }
  },
  mounted() {
    this.checkCepTimeout = null

    this.$EventBus.$on('changePaymentMethod', (paymentMethod) => {
      if (paymentMethod.indexOf('galaxpay') > -1) {
        this.$api
        .get('/assets/countries.json?v1').then((response) => {
          this.countries = response.data
        })
      }
    })
  },
  methods: {
    next() {
      this.basket.processing = true

      this.$api
      .post('/api/v1/checkout/order/create', {
        payment_method: this.paymentMethod,
        basket: this.basket
      })
      .then((response) => {
        if (response.data && parseInt(response.data.orderId) > 0) {
          window.location.href =
            '/checkout/complete?orderId=' + response.data.orderId + '&orderNumber=' + response.data.orderNumber
        } else {
          this.$vs.notify({
            time: 6000,
            text: 'Não foi possível processar seu pedido. Atualize a página e tente novamente.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })

          this.basket.processing = false
        }
      })
      .catch((error) => {
        this.basket.processing = false

        let errors = []
        if (error.response && error.response.data.message) {
          errors.push(error.response.data.message)
        } else if (error.response) {
          for (const key in error.response.data) {
            if (Object.hasOwnProperty.call(error.response.data, key)) {
              const element = error.response.data[key]
              errors.push(element)
            }
          }
        }

        this.$vs.notify({
          time: 6000,
          text: errors.join('<br>'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
    checkCep() {
      const cep = this.basket.address_postcode.replace(/[^0-9]/g, '')
      if (cep.length === 8) {

        this.$api
        .post('/api/v1/checkout/cep', {
          cep: cep
        })
        .then(response => {
          if (response.data.logradouro) {
            this.basket.address_street = response.data.logradouro
            this.basket.address_city = response.data.cidade
            this.basket.address_complement = response.data.bairro
            this.basket.address_state = response.data.estado
          }
        })
      }
    },
  }
}
</script>
